import api from './index';

export const triiderLogin = async (user) => {
  try {
    const { data } = await api.post('/companies/login', user);

    return data;
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (email) => {
  try {
    const { data } = await api.post('/users/password-reset?source=company', { email });

    return data;
  } catch (error) {
    throw error;
  }
};

export const checkTokenPassword = async (email, token) => {
  try {
    const { data } = await api.get(`/users/password-reset/${token}/${email}`, { email, token });

    return data;
  } catch (error) {
    throw error;
  }
};

export const updatePassword = async (email, token, password) => {
  try {
    const { data } = await api.put('/users/password-reset', { email, token, password });

    return data;
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (fields, userId) => {
  const { data } = await api.put(`/user/${userId}`, { user: fields });
  if (!data.success) {
    throw new Error(data.error);
  }
  return data;
};

export const apiAddPhotoUser = async (photo) => {
  const formData = new FormData();
  formData.append('image', photo, photo.name);

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryZrBYP3CMDcmOz2n2',
    },
  };

  try {
    const data = await api.post('/image/profile', formData, config);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getCompaniesByUser = async (userId) => {
  try {
    const { data } = await api.get(`/companies/user/${userId}/companies-by-user`);
    return data;
  } catch (error) {
    throw error;
  }
};


export const setSessionCompanyUser = async (triiderUser) => {
  try {
    const { data } = await api.put(`/companies/${triiderUser.company.id}/set-company-session`, { triiderUser });
    return data;
  } catch (error) {
    throw error;
  }
};
